import { Component, OnInit, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { PackageReceiveService } from '../../data-services/package.receive.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { PackageDataService } from '../../data-services/package.service';
import { ShipmentDataService } from '../../data-services/shipment.service';
import { ClientDataService } from '../../data-services/client.service';
import { ConfirmationService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { CommonModule } from '@angular/common';
import { Toast } from 'primeng/toast';
import { PackageReceiveProgressComponent } from './package.receive.progress';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'package-receive-scan',
  templateUrl: './package.receive.scan.html',
  styleUrls: ['./step.css'],
  providers: [MessageService, ConfirmationService],
  imports: [FormsModule, ConfirmDialog, CommonModule, Toast, PackageReceiveProgressComponent, CardModule]
})
export class PackageReceiveScanComponent implements OnInit, AfterViewInit {

  @ViewChild('searchTracking') searchTracking;

  package: PackageReceiveService;
  showSpinner: boolean = false;

  constructor(private packageDataService: PackageDataService,
    private clientDataService: ClientDataService,
    private shipmentService: ShipmentDataService,
    private packageReceiveSvc: PackageReceiveService,
    private messageService: MessageService,
    private router: Router,
    private datepipe: DatePipe,
    private confirmationService: ConfirmationService) {
    this.package = packageReceiveSvc;
    this.package.stepnumber = 1;
  }

  ngOnInit() {
    this.package.reset();
  }

  ngAfterViewInit() {
    this.searchTracking.nativeElement.focus();
  }

  nextPage() {
    if (!this.package.packageFound || !this.package.DeliveredDate) {
      this.router.navigate(['package-receive-new/package-receive-shipper']);
    } else if (!this.package.FromAddress1) {
      this.router.navigate(['package-receive-new/package-receive-sender']);
    } else if (!this.package.client) {
      this.router.navigate(['package-receive-new/package-receive-client']);
    } else {
      this.router.navigate(['package-receive-new/package-receive-review']);
    }
  }

  goToSender() {
    this.router.navigate(['package-receive-new/package-receive-sender']);
  }

  barcode = "";
  barcodeReading = false;

  @HostListener('document:keypress', ['$event'])
  handleScannerInput(event) {
    this.handleKeystroke(event.keyCode, event.key);
  }

  handleKeystroke(keyCode, key) {
    //usually scanners throw an 'Enter' key at the end of read
    if (keyCode === 13) {
      this.handleBarCode(this.package.trackingNumber);
      this.barcode = "";
    } else {
      this.barcode += key;//while this is not an 'enter' it stores the every key            
    }

    //run a timeout of 200ms at the first read and clear everything
    if (!this.barcodeReading) {
      this.barcodeReading = true;
      setTimeout(() => {
        this.barcode = "";
        this.barcodeReading = false;
      }, 200);
    }
  }

  public handleSearchButton() {
    this.handleBarCode(this.package.trackingNumber);
  }

  handleBarCode(code: string) {
    var id = code.replace(/[^ -~]+/g, ""); //remove nondisplayable characters
    if (!id) {
      return;
    }
    if (id.length > 12) {
      id = id.slice(id.length - 12)
    }
    console.log('barcode: ' + id);
    this.checkForDuplicate(id);
  }

  private checkForDuplicate(trackingId: string) {
    this.showSpinner = true;
    this.packageDataService.hasTrackingNumberBeenReceived(trackingId).subscribe((data: boolean) => {
      if (!data) {
        this.lookupTrackingId(trackingId);
      }
      else {
        //this.messageService.add({ severity: 'error', summary: 'Package', detail: 'Tracking Id ' + trackingId + ' has already been processed', life: 6000, closable: true, sticky: true });
        this.showSpinner = false;
        this.getExistingPackageInfo(trackingId);
      }
    },
      (err) => {
        this.messageService.add({ key: trackingId, severity: 'error', summary: 'Package', detail: 'Error checking for duplicates: ' + err.status, life: 6000, closable: true, sticky: true });
        this.showSpinner = false;
      });
  }

  private getExistingPackageInfo(trackingId: string) {
    this.packageDataService.getPackageByTrackingId(trackingId).subscribe((data: any) => {
      var info: string = "The tracking ID " + trackingId + " has already been processed";
      if (data.ReceivedDate) {
        info = info + ", received on " + this.datepipe.transform(data.ReceivedDate, 'MM/dd/yyyy');
      }
      if (data.OpenedDate) {
        info = info + ", opened on " + this.datepipe.transform(data.OpenedDate, 'MM/dd/yyyy');
      }
      if (data.CompletedDate) {
        info = info + ", completed on " + this.datepipe.transform(data.CompletedDate, 'MM/dd/yyyy');
      }
      info = info + ". If this is a duplicate tracking ID please give to a supervisor for processing.";

      this.confirmationService.confirm({
        message: info,
        acceptLabel: 'Given To Supervisor',
        rejectVisible: false,
        accept: () => {
          this.package.trackingNumber = "";
          this.searchTracking.nativeElement.focus();
        }
      });

    });
  }

  private lookupTrackingId(trackingId: string) {
    var d = new Date();
    d.setDate(d.getDate() - 1);
    var minDateValue = d;
    var maxDateValue = new Date();

    this.shipmentService.getPackageByTrackingNumber(trackingId).subscribe((data: any) => {
      this.package.trackingNumber = trackingId;
      if (data) {
        this.package.FromName = data.FromCompany;
        if (!this.package.FromName) {
          this.package.FromName = data.FromName;
        }
        this.package.ShipmentType = data.ShipmentType;
        this.package.shipmentTypeDisplay = this.package.shipmenttypes.filter(xx => xx.value.trim() == this.package.ShipmentType).length > 0 ? this.package.shipmenttypes.filter(xx => xx.value.trim() == this.package.ShipmentType)[0].label : "";
        this.package.FromAddress1 = data.FromAddress1;
        this.package.FromCity = data.FromCity;
        this.package.FromState = data.FromState;
        this.package.FromZipCode = data.FromZipCode;
        this.package.DeliveredDate = new Date(data.DeliveredDate);

        if (this.package.DeliveredDate > maxDateValue || this.package.DeliveredDate < minDateValue) {
          this.package.DeliveredDate = null;
        }

        this.package.packageFound = true;
        this.findClient();
      } else {
        this.package.ShipmentType = "";
        this.package.shipmentTypeDisplay = "";
        this.package.FromAddress1 = "";
        this.package.FromCity = "";
        this.package.FromState = "";
        this.package.FromZipCode = "";
        this.package.DeliveredDate = new Date();
        this.package.packageFound = false;
        this.package.cantChangeShipper = false;
        this.showSpinner = false;
        this.nextPage();
      }
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Package', detail: 'Error looking for Tracking Id: ' + err.status, life: 6000, closable: true, sticky: true });
        this.showSpinner = false;
      });
  }

  private findClient() {
    this.package.client = {};
    var dto: any = {};
    dto.Name = this.package.FromName;
    dto.Address1 = this.package.FromAddress1;
    dto.City = this.package.FromCity;
    dto.State = this.package.FromState;
    dto.Zip = this.package.FromZipCode;
    this.clientDataService.getClientByAddress(dto).subscribe((data: any) => {
      if (data == null) {
        this.package.client = null;
      } else {
        data.OriginalName = data.Name;
        this.package.FromName = data.Name;
        this.package.client = data;
      }
      this.showSpinner = false;
      this.nextPage();
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Package', detail: 'Error looking for Client: ' + err.status, life: 6000, closable: true, sticky: true });
        this.showSpinner = false;
      });
  }

  generateTrackingNumber() {
    this.showSpinner = true;
    var trackingId = this.makeid(12);
    this.packageDataService.hasTrackingNumberBeenReceived(trackingId).subscribe((data: boolean) => {
      if (!data) {
        this.package.trackingNumber = trackingId;
        this.nextPage();
      }
      else {
        // try again
        this.generateTrackingNumber();
      }
    },
      (err) => {
        this.messageService.add({ key: this.package.trackingNumber, severity: 'error', summary: 'Package', detail: 'Error checking for duplicates: ' + err.status, life: 6000, closable: true, sticky: true });
        this.showSpinner = false;
      });
  }

  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
